import { DEFAULT_VIEW_ID } from 'dashboard409a/pages/Workboard/common/constants';

export const isPinnedSavedViewTab = (viewId: string): boolean => viewId === DEFAULT_VIEW_ID;

const normalizeSavedViewIds = (savedOrder: readonly string[] | null | undefined): string[] => {
  if (!Array.isArray(savedOrder)) {
    return [];
  }

  const seen = new Set<string>();
  const ids: string[] = [];
  savedOrder.forEach(id => {
    if (typeof id !== 'string' || id.length === 0 || seen.has(id)) {
      return;
    }
    seen.add(id);
    ids.push(id);
  });
  return ids;
};

// Personal tab order is browser-only. The pinned tab stays first, deleted ids are dropped,
// and views missing from the saved list are appended in server order.
export const applySavedViewTabOrder = <T extends { id: string }>(
  views: readonly T[],
  savedOrder: readonly string[] | null | undefined
): T[] => {
  const savedIds = normalizeSavedViewIds(savedOrder);
  const viewsById = new Map(views.map(view => [view.id, view]));
  const ordered: T[] = [];
  const seen = new Set<string>();

  const pinnedView = views.find(view => isPinnedSavedViewTab(view.id));
  if (pinnedView) {
    ordered.push(pinnedView);
    seen.add(pinnedView.id);
  }

  savedIds.forEach(id => {
    if (seen.has(id)) {
      return;
    }
    const view = viewsById.get(id);
    if (!view) {
      return;
    }
    ordered.push(view);
    seen.add(id);
  });

  views.forEach(view => {
    if (seen.has(view.id)) {
      return;
    }
    ordered.push(view);
  });

  return ordered;
};
